import React, { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormInput from "./components/FormInput";
import ProcessingBar from "utils/Processingbar";
import Button from "../../components/Button";
import TimeSlotSelector from "./components/TimeSlotSelector";
import OrderingMethodSelector from "./components/OrderingMethod";
import ContactInfo from "./components/ContactInfo";
import PaymentMethodSelector from "./components/PaymentMethodSelector";
import Summary from "./components/Summary";

const RenderMain = ({ formData, setFormData, currentStep, handleNext }) => {
  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const index = currentStep + 1;

  const renderStepContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <TimeSlotSelector
            selectedDateTime={formData.selectedDateTime}
            setSelectedDateTime={(value) =>
              handleChange("selectedDateTime", value)
            }
            onNext={handleNext} // <- Pass this down
          />
        );
      case 1:
        return (
          <OrderingMethodSelector
            selected={formData.orderingMethod}
            onChange={(val) => {
              handleChange("orderingMethod", val);
              handleNext(); // ✅ Trigger next step after selection
            }}
          />
        );
      case 2:
        return (
          <PaymentMethodSelector
            selected={formData.paymentMethod}
            onChange={(val) => {
              handleChange("paymentMethod", val);
              handleNext(); // ✅ Trigger next step after selection
            }}
          />
        );
      case 3:
        return <ContactInfo formData={formData} onChange={handleChange} />;

      default:
        return null;
    }
  };

  return (
    <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8">
      <h2 className="text-3xl lg:text-4xl font-semibold">
        Process to CheckOut
      </h2>
      <div className="border-b border-neutral-200 dark:border-neutral-700"></div>

      <div className="border-b border-border">
        <span className="text-4xl font-semibold">{index}</span>{" "}
        <span className="text-lg text-text">/ 4</span>
      </div>

      {renderStepContent()}
    </div>
  );
};

export default RenderMain;
